import { render, staticRenderFns } from "./Dynamics.vue?vue&type=template&id=1db6a22c&scoped=true"
import script from "./Dynamics.vue?vue&type=script&lang=ts"
export * from "./Dynamics.vue?vue&type=script&lang=ts"
import style0 from "./Dynamics.vue?vue&type=style&index=0&id=1db6a22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6a22c",
  null
  
)

export default component.exports